var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDashboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_home",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home_FILL0_wght300_GRAD-25_opsz20",
    d: "M188.759-777.6H191.8v-5.87h5.466v5.87h3.042v-8.683l-5.776-4.351-5.776,4.349Zm0,1.488a1.429,1.429,0,0,1-1.047-.439,1.431,1.431,0,0,1-.439-1.049v-8.683a1.474,1.474,0,0,1,.155-.667,1.357,1.357,0,0,1,.449-.515l5.78-4.354a1.5,1.5,0,0,1,.414-.214,1.456,1.456,0,0,1,.473-.079,1.4,1.4,0,0,1,.466.079,1.525,1.525,0,0,1,.408.214l5.78,4.354a1.357,1.357,0,0,1,.449.515,1.474,1.474,0,0,1,.155.667v8.683a1.431,1.431,0,0,1-.439,1.049,1.432,1.432,0,0,1-1.049.439h-4.53v-5.87h-2.491v5.87ZM194.534-784.131Z",
    transform: "translate(-165.534 882.114)",
    fill: "#8d8d8d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dashboard.2d32b0c5.svg";
export { ForwardRef as ReactComponent };